export default [
  {
    date: 1462623992377,
    row: 5,
    col: 17,
    segments: [
      [1, 5, 1, 4],
      [1, 4, 2, 4],
      [2, 4, 3, 3],
      [3, 3, 4, 3],
      [4, 3, 4, 2],
      [4, 2, 5, 1],
      [5, 1, 6, 2],
      [6, 2, 6, 3],
      [6, 3, 7, 3],
      [7, 3, 8, 4],
      [8, 4, 9, 4],
      [9, 4, 10, 4],
      [10, 4, 11, 3],
      [11, 3, 12, 3],
      [12, 3, 12, 2],
      [12, 2, 13, 1],
      [13, 1, 14, 2],
      [14, 2, 14, 3],
      [14, 3, 15, 3],
      [15, 3, 16, 4],
      [1, 5, 2, 5],
      [2, 5, 3, 4],
      [3, 4, 4, 5],
      [4, 5, 6, 5],
      [6, 5, 7, 4],
      [7, 4, 8, 5],
      [8, 5, 9, 5],
      [9, 5, 10, 5],
      [10, 5, 11, 4],
      [11, 4, 12, 5],
      [12, 5, 14, 5],
      [14, 5, 15, 4],
      [15, 4, 16, 5],
      [16, 5, 17, 5],
      [17, 5, 17, 4],
      [17, 4, 16, 4]
    ]
  }
];
